'use client';

import {useEffect, useRef, useState} from 'react';
import cn from './style.module.scss';

interface ParallaxBlockProps {
  height?: string;
  animationType?:
    | 'zoomIn'
    | 'zoomOut'
    | 'slideInLeft'
    | 'slideInRight'
    | 'slideInTop'
    | 'slideInBottom';
  animationDuration?: number;
  children?: React.ReactNode;
}

const ParallaxBlock: React.FC<ParallaxBlockProps> = ({
  animationType = 'zoomIn',
  animationDuration = 1000,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {threshold: 0.3}
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const animationClass = cn[animationType as keyof typeof cn] || '';

  return (
    <div
      ref={sectionRef}
      className={`${cn.animatedBlock} ${isVisible ? animationClass : ''}`}
      style={{transition: `all ${animationDuration}ms ease-out`}}>
      {children}
    </div>
  );
};

export default ParallaxBlock;
